import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllFarmSuccess,
  getAllFarmFailed,
  GET_ALL_FARM_START,
} from '../../actions/farm'

/**
 * get list farm
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListFarmApi = (props) => {
  var uri = `/farms`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListFarm(action) {
  try {
    const response = yield call(getListFarmApi, action?.payload)
    yield put(getAllFarmSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllFarmFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list farm
 */
export default function* watchGetListFarm() {
  yield takeLatest(GET_ALL_FARM_START, doGetListFarm)
}
